module.exports = function () {

    function generateNewItemFields(index) {

        var newFieldGroup =
            '<div class="expense-to-add">'+
            '<div class="row"><div class="col-sm-4">' +
            '<button class="btn btn-expense btn-remove" type="button"><i class="glyphicon glyphicon-remove"></i></button>' +
            '</div></div> ' +
            '<div class="row">' +
            '<div class="col-sm-6"><div class="form-group ">' +
            '<label for="pettycash[' + index + '][user_id]" class="control-label col-sm-5 label-required">Employee Name</label>' +
            '<div class="col-sm-7">' +
            '<input class="form-control typeahead" name="pettycash[' + index + '][user_id]" type="text" id="pettycash[' + index + '][user_id]"></div></div></div>' +
            '<div class="col-sm-6"><div class="form-group">' +
            '<label for="pettycash[' + index + '][file]" class="control-label col-sm-5">File</label>' +
            '<div class="col-sm-7">' +
            '<div class="input-image">' +
            '<input class="form-control" name="pettycash[' + index + '][file]" type="file" id="pettycash[' + index + '][file]"></div></div></div>' +
            '<div class="clearfix"></div></div></div>' +
            '<div class="row">' +
            '<div class="col-sm-6"><div class="form-group ">' +
            '<label for="pettycash[' + index + '][date]" class="control-label col-sm-5 label-required">Date</label>' +
            '<div class="col-sm-7">' +
            '<input class="form-control js-datepicker" required="required" name="pettycash[' + index + '][date]" type="text" id="pettycash[' + index + '][date]"></div></div></div>' +
            '<div class="col-sm-6"><div class="form-group ">' +
            '<label for="pettycash[' + index + '][amount]" class="control-label col-sm-5 label-required">Amount</label>' +
            '<div class="col-sm-7">' +
            '<input class="form-control" required="required" name="pettycash[' + index + '][amount]" type="text" id="pettycash[' + index + '][amount]"></div></div></div></div>' +
            '<div class="row">' +
            '<div class="col-sm-6">' +
            '<div class="form-group ">' +
            '<label for="pettycash[' + index + '][description]" class="control-label col-sm-3">Description</label>' +
            '<div class="col-sm-9">' +
            '<textarea class="form-control" name="pettycash[' + index + '][description]" type="text" id="pettycash[' + index + '][description]"></textarea>' +
            '</div></div></div></div></div>';

        return newFieldGroup;
    }

    function typeahead_initialize(){

        var helper = require('../../helper');

        /** Make engine object */
        var engine = new Bloodhound({
            datumTokenizer: function (datum) {
                return Bloodhound.tokenizers.whitespace(datum.name);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: helper.getOrigin() + "/api/staff/search/%QUERY",
                wildcard: '%QUERY'
            },
            filter: function (response) {
                return $.map(response.properties, function (object) {
                    return {
                        id: object.id,
                        fullName: object.fullName
                    };
                });
            }
        });

        $('.typeahead').typeahead(null, {
            minLength: 1,
            display: 'fullName',
            valueKey: 'id',
            name: 'suggestions',
            displayKey: 'fullName',
            limit: 15,
            templates: {
                empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'Unable to find users', '</strong></div>'].join('\n'),
                suggestion: function (data) {
                    return '<p style="font-size: 100%; cursor: pointer;"><strong>' + data.fullName + '</strong></p>';
                }
            },
            source: engine
        });
    }

    $(document).ready(function () {

        $(document).on('click', '.js-datepicker', function (e) {
            $(this).datepicker({
                autoclose: true,
                format: "dd/mm/yyyy"
            });

        }).on('click', '.btn-remove', function (e) {

            $(this).parents('.row:first').parents('.expense-to-add').remove();

            e.preventDefault();
            return false;

        }).on('click', '.btn-add-new', function (e) {

            var wrapper = $('#add-many-expenses-wrapper'),
                globalIndex = wrapper.data('index');

            var newFieldGroup = generateNewItemFields(++globalIndex, null);

            var controlForm = $('.controls');

            $(newFieldGroup).appendTo(controlForm);

            wrapper.data('index', globalIndex);

            $('.typeahead').typeahead('destroy');
            typeahead_initialize();
        });
    });
}();
